export const truncateDecimals = (num) => {
  if (
    num === null ||
    num === undefined ||
    num === "null" ||
    num === "undefined" ||
    num === "NaN" ||
    isNaN(Number(num))
  ) {
    return null;
  }
  const [integerPart, decimalPart = ""] = num.toString().split(".");

  // Ensure there are exactly 3 decimal places
  let formattedDecimalPart = decimalPart.substring(0, 3);
  while (formattedDecimalPart.length < 3) {
    formattedDecimalPart += "0";
  }
  return `${integerPart}.${formattedDecimalPart}`;
};
